<template>
    <v-container fill-height fluid grid-list-xl>
        <v-card>
            <v-card-title class="headline ma-3">Class</v-card-title>
            <v-form ref="classForm" lazy-validation>
                <v-container>
                    <v-layout wrap class="pa-3">
                        <v-flex xs8>
                            <v-layout row>
                                <v-flex xs4>
                                    <v-text-field
                                        label="Reg ID"
                                        v-model="classSetup.regId"
                                        :rules="[rules.required]"
                                    />
                                </v-flex>
                                <v-flex xs4>
                                    <v-select
                                        :items="['Girls Camp', 'Bunk']"
                                        v-model="classSetup.classType"
                                        label="Type"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs8>
                            <v-layout row>
                                <v-flex xs4>
                                    <v-text-field
                                        label="Class Name"
                                        v-model="classSetup.className"
                                    />
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        label="Grade"
                                        v-model="classSetup.grade"
                                        :rules="[rules.required]"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs8>
                            <v-layout row>
                                <v-flex xs4>
                                    <v-text-field
                                        label="Teacher"
                                        v-model="classSetup.teacher"
                                    />
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        label="Building"
                                        v-model="classSetup.building"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                            <v-flex xs2>
                                <v-text-field
                                    label="Room Number"
                                    type="number"
                                    v-model="classSetup.roomNumber"
                                />
                            </v-flex>
                        </v-flex>
                        <v-flex class="xs12 text-xs-right">
                            <v-btn class="mr-2" @click.stop="cancel"
                                >Cancel</v-btn
                            >
                            <v-btn
                                v-if="classSetup.classID != ''"
                                class="mr-2"
                                @click="confirmDialog = true"
                                >Delete</v-btn
                            >
                            <v-btn color="success" @click.stop="saveClass"
                                >Save</v-btn
                            >
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-card>
        <v-dialog v-model="confirmDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-danger headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2"
                    >This will delete the class of
                    <br />
                    <div class="mt-1 font-weight-medium">
                        {{ classSetup.teacher }}
                    </div></v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="confirmDialog = false">Cancel</v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteClass"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "../../utils/ky.js";

export default {
    data: () => ({
        classSetup: {
            classID: "",
            regId: "",
            classType: "",
            className: "",
            grade: "",
            teacher: "",
            building: "",
            roomNumber: "",
        },

        confirmDialog: false,
        processing: false,

        rules: {
            required: (value) => !!value || "Required.",
        },
    }),
    async created() {
        if (
            this.$route.params.id == null ||
            this.$route.params.id === undefined
        ) {
            await this.loadRegID();
        }

        this.load();
    },
    methods: {
        async load() {
            if (
                this.$route.params.id == null ||
                this.$route.params.id === undefined
            )
                return;

            const response = await this.$http.get(
                "api/classSetup/getClass?id=" + this.$route.params.id
            );

            this.classSetup.classID = response.classID;
            this.classSetup.regId = response.regID;
            this.classSetup.classType = response.classType;
            this.classSetup.className = response.className;
            this.classSetup.grade = response.grade;
            this.classSetup.teacher = response.teacher;
            this.classSetup.building = response.building;
            this.classSetup.roomNumber = response.roomNumber;
        },
        cancel() {
            this.$router.push({
                name: "GirlsCampClasses",
            });
        },
        async loadRegID() {
            this.classSetup.regId = "GC2020";
        },
        async saveClass() {
            if (!this.$refs.classForm.validate()) return;

            const isUpdating = this.classSetup.classID != "";

            if (isUpdating) {
                await ky.post(this.$Progress, "api/classSetup/update", {
                    data: this.classSetup,
                });
            } else {
                delete this.classSetup.classID;

                await ky.post(this.$Progress, "api/classSetup/add", {
                    data: this.classSetup,
                });
            }

            this.$router.push({
                name: "GirlsCampClasses",
            });
        },
        async deleteClass() {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/classSetup/delete?classID=" + this.classSetup.classID
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.confirmDialog = false;

            this.$router.push({
                name: "GirlsCampClasses",
            });
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
</style>
